import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, Center, Spinner } from '@chakra-ui/react';
import { getTrackPathPrefix } from '@src/components/sco/Education/ContentTrackContext';
import { Step } from '@src/components/sco/Education/ContentTrackStepDetail/Steps';
import { ArticleStep } from '@src/components/sco/Education/ContentTrackStepDetail/Steps/ArticleStep';
import { PodcastStep } from '@src/components/sco/Education/ContentTrackStepDetail/Steps/PodcastStep';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { EducationErrorState } from '@src/components/sco/Education/EducationErrorState';
import { UserAccessGate } from '@src/components/sco/UserAccessGate';
import { ContentTrack, ContentTrackSection, ContentTrackStep } from '@src/graphql-types';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { gql } from '@src/lib/gql';
import { useQueryState } from 'nuqs';
import React from 'react';
type ContentTracksStepDetailProps = {
  contentTrackSlug: string;
  contentTrackSectionSlug: string;
  contentTrackStepSlug: string;
};
export const ContentTrackStepDetail = props => {
  const $ = _c(39);
  useQueryState("prompt");
  const educationContext = useEducationContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ContentTrackStepDetail.queries.contentTrackStep();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props.contentTrackSectionSlug || $[2] !== props.contentTrackSlug || $[3] !== props.contentTrackStepSlug) {
    t1 = {
      variables: {
        contentTrackSlug: props.contentTrackSlug,
        contentTrackSectionSlug: props.contentTrackSectionSlug,
        contentTrackStepSlug: props.contentTrackStepSlug
      }
    };
    $[1] = props.contentTrackSectionSlug;
    $[2] = props.contentTrackSlug;
    $[3] = props.contentTrackStepSlug;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const query = useQuery(t0, t1);
  const contentTrackStep = query.data?.contentTrackSteps[0];
  const contentTrackSection = contentTrackStep?.parentContentTrackSection;
  const contentTrack = contentTrackSection?.parentContentTrack;
  let t2;
  if ($[5] !== contentTrack || $[6] !== contentTrackSection?.slug || $[7] !== contentTrackSection?.title || $[8] !== contentTrackStep || $[9] !== educationContext) {
    t2 = () => {
      if (contentTrackStep) {
        educationContext.setActiveContentItem(contentTrackStep);
        educationContext.setBreadcrumbs([{
          title: "Courses",
          href: "/courses"
        }, {
          title: contentTrack?.title || "...",
          href: `/${getTrackPathPrefix(contentTrack)}/${contentTrack?.slug}`
        }, {
          title: contentTrackSection?.title || "...",
          href: `/${getTrackPathPrefix(contentTrack)}/${contentTrack?.slug}/${contentTrackSection?.slug}`
        }, {
          title: contentTrackStep?.title,
          href: `/${getTrackPathPrefix(contentTrack)}/${contentTrack?.slug}/${contentTrackSection?.slug}/${contentTrackStep?.slug}`
        }]);
      }
    };
    $[5] = contentTrack;
    $[6] = contentTrackSection?.slug;
    $[7] = contentTrackSection?.title;
    $[8] = contentTrackStep;
    $[9] = educationContext;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const t3 = contentTrackStep?.title;
  const t4 = contentTrack?.slug;
  const t5 = contentTrackSection?.slug;
  let t6;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = [t3, t4, t5];
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  useUniversalEffect(t2, t6);
  let t7;
  if ($[15] !== contentTrack?.sections || $[16] !== contentTrackSection?.id) {
    t7 = contentTrack?.sections?.findIndex(section => section.id == contentTrackSection?.id);
    $[15] = contentTrack?.sections;
    $[16] = contentTrackSection?.id;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const isStepInFirstSection = t7 <= 1;
  let t8;
  if ($[18] !== contentTrack?.sections || $[19] !== contentTrackSection?.id) {
    t8 = contentTrack?.sections?.findIndex(section_0 => section_0.id == contentTrackSection?.id);
    $[18] = contentTrack?.sections;
    $[19] = contentTrackSection?.id;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const isStepInSecondSection = t8 <= 2;
  let t9;
  if ($[21] !== query.loading) {
    t9 = query.loading && <Center padding={10}><Spinner /></Center>;
    $[21] = query.loading;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== query.error) {
    t10 = query.error && <Box>{"Error: "}{`${query.error?.toString()}`}</Box>;
    $[23] = query.error;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== contentTrackStep || $[26] !== query.loading) {
    t11 = !query.loading && !contentTrackStep && <EducationErrorState ctaHref="/courses" ctaLabel="Explore All Courses" headingText="Course Step Not Found" />;
    $[25] = contentTrackStep;
    $[26] = query.loading;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== contentTrack || $[29] !== contentTrackSection || $[30] !== contentTrackStep || $[31] !== isStepInFirstSection || $[32] !== isStepInSecondSection) {
    t12 = contentTrackStep && contentTrackSection && contentTrack && <UserAccessGate bypass={isStepInFirstSection || isStepInSecondSection} ctaVariant="page-overlay" require={{
      isRegistered: true
    }} ctaProps={{
      wrapperProps: {
        padding: "1em"
      },
      boxProps: {
        maxWidth: "30em",
        marginTop: "10%",
        marginX: "auto"
      },
      title: "Register to Continue",
      subtitle: "We hope this course has been helpful! Create a free account to continue with the rest of the course.",
      emailCaptureProps: {}
    }}><UserAccessGate bypass={isStepInFirstSection || isStepInSecondSection} ctaVariant="page-overlay" require={{
        contentPermissions: ["canAccessCourses"]
      }} ctaProps={{
        isDismissible: true,
        title: "Upgrade to unlock this and all other courses.",
        wrapperProps: {
          padding: "1em"
        },
        boxProps: {
          maxWidth: "30em",
          marginTop: "10%",
          marginX: "auto"
        }
      }}><Step contentTrackStep={contentTrackStep} /></UserAccessGate></UserAccessGate>;
    $[28] = contentTrack;
    $[29] = contentTrackSection;
    $[30] = contentTrackStep;
    $[31] = isStepInFirstSection;
    $[32] = isStepInSecondSection;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t10 || $[35] !== t11 || $[36] !== t12 || $[37] !== t9) {
    t13 = <Box>{t9}{t10}{t11}{t12}</Box>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t12;
    $[37] = t9;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  return t13;
};
ContentTrackStepDetail.queries = {
  contentTrackStep: () => gql`
    query ($contentTrackSlug: String, $contentTrackSectionSlug: String, $contentTrackStepSlug: String) {
      contentTrackSteps(
        where: {
          parentContentTrackSection: {
            slug: $contentTrackSectionSlug
            parentContentTrack: { slug: $contentTrackSlug }
          }
          slug: $contentTrackStepSlug
        }
        first: 1
      ) {
        id
        title
        slug
        body
        video {
          id
          sourceUrl
          playbackDurationInSeconds
          playbackStartInSeconds
          playbackEndInSeconds
        }
        contentAttachments {
          ${ArticleStep.fragments.Article()}
          ${PodcastStep.fragments.PodcastEpisode()}
          __typename
        }
        customReactComponent {
          ${Step.fragments.ContentTrackReactComponent()}
          __typename
        }
        tasks {
          id
          title
          action {
            ${Step.fragments.ContentTrackPrompt()}
            ${Step.fragments.ContentTrackCallToAction()}
            ${Step.fragments.ContentTrackReactComponent()}
            __typename
          }
        }
        parentContentTrackSection {
          id
          title
          slug
          color {
            hex
          }
          parentContentTrack {
            id
            title
            type
            slug
            sections {
              id
            }
            color {
              hex
            }
          }
        }
      }
    }
  `
};